import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./pick_unit_modal_slider.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
